const DB_NAME = 'pulsify-drafts'
const STORE = 'drafts'

function openDb(): Promise<IDBDatabase | null> {
  return new Promise((resolve) => {
    try {
      if (typeof indexedDB === 'undefined') {
        resolve(null)
        return
      }
      const request = indexedDB.open(DB_NAME, 1)
      request.onupgradeneeded = () => request.result.createObjectStore(STORE)
      request.onsuccess = () => resolve(request.result)
      request.onerror = () => resolve(null)
      request.onblocked = () => resolve(null)
    } catch {
      resolve(null)
    }
  })
}

async function run<T>(
  mode: IDBTransactionMode,
  work: (store: IDBObjectStore) => IDBRequest<T>,
): Promise<T | null> {
  const db = await openDb()
  if (!db) return null
  return new Promise((resolve) => {
    try {
      const tx = db.transaction(STORE, mode)
      const request = work(tx.objectStore(STORE))
      tx.oncomplete = () => {
        db.close()
        resolve(request.result ?? null)
      }
      tx.onerror = () => {
        db.close()
        resolve(null)
      }
      tx.onabort = () => {
        db.close()
        resolve(null)
      }
    } catch {
      db.close()
      resolve(null)
    }
  })
}

export const draftStore = {
  read<T>(key: string): Promise<T | null> {
    return run<T>('readonly', (store) => store.get(key))
  },
  async write(key: string, value: unknown): Promise<void> {
    await run('readwrite', (store) => store.put(value, key))
  },
  async remove(key: string): Promise<void> {
    await run('readwrite', (store) => store.delete(key))
  },
}
